const wealthBuildingSteps = [

  {
    id: 21,
    decision: true,
    area: 'Wealth Building Stage',
    options: [
      { text: 'Undebting (81-100%) Net Worth = Very Negative Pay off debt.', nextStep: 22,  stage: 'Undebting' },
      { text: 'Saving (61-80%) Net Worth = Negative Pay off debt and save.', nextStep: 2,  stage: 'Saving' },
      { text: 'Securing (21-40%) Net Worth = Positive Pay off debt, save, invest and document legacy.', nextStep: 3,  stage: 'Securing' },
      { text: 'Saving (61-80%) Net Worth = Negative Pay off debt and save.', nextStep: 3,  stage: 'Saving' },
    ]
  },
  {
    id: 22,
    area: 'Wealth Building Stage',
    stage: 'Undebting',
    stepTitle: 'Fill out income and spending for past 12 months and identify areas in need of more sacrifice and discipline.',
    formFields: [
      { id: 'incomeAfterTax', title: 'Income After-tax salary or wages (Past 12 Months)', type: 'number', maxChars: 100 },
      { id: 'additionalIncome', title: 'Any additional income (Past 12 Months)', type: 'number', maxChars: 100 },
    ],
    nextStep: 23,
  },

  {
    id: 23,
    stage: 'Undebting',
    area: 'Wealth Building Stage',
    stepTitle: 'Needs/Necessities.',
    stepDescription: 'Document your expenses for the past 12 months.',
    formFields: [
      { id: 'rentMortgage', title: 'Rent-mortgage', type: 'number', maxChars: 100 },
      { id: 'homeownersInsurance', title: 'Homeowners or renters insurance premiums', type: 'number', maxChars: 100 },
      { id: 'propertyTax', title: 'Property tax (if not already included in the mortgage payment)', type: 'number', maxChars: 100 },
      { id: 'autoInsurance', title: 'Auto insurance premiums', type: 'number', maxChars: 100 },
      { id: 'healthInsurance', title: 'Health insurance premiums', type: 'number', maxChars: 100 },
      { id: 'medicalCosts', title: 'Out-of-pocket medical costs', type: 'number', maxChars: 100 },
      { id: 'lifeInsurance', title: 'Life insurance premiums', type: 'number', maxChars: 100 },
      { id: 'electricityGas', title: 'Electricity and natural gas bill', type: 'number', maxChars: 100 },
      { id: 'waterBill', title: 'Water bill', type: 'number', maxChars: 100 },
      { id: 'garbageBill', title: 'Sanitation-garbage bill', type: 'number', maxChars: 100 },
      { id: 'groceriesEssentials', title: 'Groceries, toiletries and other essentials', type: 'number', maxChars: 100 },
      { id: 'carPayment', title: 'Car payment', type: 'number', maxChars: 100 },
      { id: 'parkingFees', title: 'Parking and registration fees', type: 'number', maxChars: 100 },
      { id: 'carMaintenance', title: 'Car maintenance and repairs', type: 'number', maxChars: 100 },
      { id: 'gasoline', title: 'Gasoline', type: 'number', maxChars: 100 },
      { id: 'publicTransport', title: 'Public transportation', type: 'number', maxChars: 100 },
      { id: 'phoneBill', title: 'Phone bill', type: 'number', maxChars: 100 },
      { id: 'internetBill', title: 'Internet bill', type: 'number', maxChars: 100 },
      { id: 'studentLoans', title: 'Minimum student loan payments', type: 'number', maxChars: 100 },
      { id: 'otherLoans', title: 'Other minimum loan payments', type: 'number', maxChars: 100 },
      { id: 'childSupport', title: 'Child support or alimony payments', type: 'number', maxChars: 100 },
      // { id: 'other', title: 'Other', type: 'number', maxChars: 500 },
    ],
    nextStep: 24, // Define the next step ID here
  },
  {
    id: 24,
    stage: 'Undebting',
    area: 'Wealth Building Stage',
    stepTitle: 'Wants/Luxuries.',
    formFields: [
      { id: 'clothingJewelry', title: 'Clothing, jewelry, etc.', type: 'number', maxChars: 100 },
      { id: 'diningOut', title: 'Dining out', type: 'number', maxChars: 100 },
      { id: 'specialMealsAtHome', title: 'Special meals at home', type: 'number', maxChars: 100 },
      { id: 'alcohol', title: 'Alcohol', type: 'number', maxChars: 100 },
      { id: 'entertainment', title: 'Movie, concert and event tickets', type: 'number', maxChars: 100 },
      { id: 'gymMembership', title: 'Gym or club memberships', type: 'number', maxChars: 100 },
      { id: 'travelExpenses', title: 'Travel expenses (airline tickets, hotels, rental cars, etc.)', type: 'number', maxChars: 100 },
      { id: 'cableStreaming', title: 'Cable or streaming packages', type: 'number', maxChars: 100 },
      { id: 'homeDecor', title: 'Home decor items', type: 'number', maxChars: 100 },
      // { id: 'otherDiscretionary', title: 'Other', type: 'number', maxChars: 500 },
    ],
    nextStep: 25, // Define the next step ID here
  },

  {
    id: 25,
    stage: 'Undebting',
    area: 'Wealth Building Stage',
    stepTitle: 'Savings and Debt Repayment',
    lastStep: true,
    formFields: [
      { id: 'emergencyFundContributions', title: 'Emergency fund contributions\n*Annual amount should cover a minimum of 6 months of needs/necessities and wants/luxuries', type: 'number', maxChars: 100 },
      { id: 'savingsAccountContributions', title: 'Savings account contributions', type: 'number', maxChars: 100 },
      { id: '401kContributions', title: '401(k) contributions', type: 'number', maxChars: 100 },
      { id: 'iraContributions', title: 'Individual retirement account contributions', type: 'number', maxChars: 100 },
      { id: 'creditCardPayments', title: 'Credit card payments', type: 'number', maxChars: 100 },
      { id: 'excessStudentLoanPayments', title: 'Excess payments on student loans', type: 'number', maxChars: 100 },
      { id: 'excessMortgagePayments', title: 'Excess payments on mortgage', type: 'number', maxChars: 100 },
    ],
    nextStep: 21, 
},

// {
//   id: 26,
//   stage: 'Undebting',
//   area: 'Wealth Building Stage',
//   stepTitle: 'Summary',
//   nextStep: null, // Define the next step ID here
//   formFields: [] // No form fields for the summary step

// }

  
];

export default wealthBuildingSteps;
